import React, { useRef, useState } from 'react'

import PropTypes from 'prop-types'

import classnames from 'classnames'

import './Uploader.scss'

export const UPLOADER_VARIANT_DEFAULT = 'default'
export const UPLOADER_VARIANT_UPLOADING = 'uploading'
export const UPLOADER_VARIANT_UPLOADED = 'uploaded'
export const UPLOADER_VARIANT_DANGER = 'danger'

export const Uploader = ({
  className,
  variant,
  inputId,
  hint,
  children,
  value,
  onChange,
  accept,
  multiple,
  disabled,
  acceptWithMimeType,

  'data-mu-test': dataAttributeTest
}) => {
  const [dragging, setDragging] = useState(false)

  const dropZoneEl = useRef(null)

  const dragEnterEl = useRef(null)

  const accepted = files => {
    let res = files
    if (acceptWithMimeType.length > 0) {
      res = Array.from(files).filter(({ name, type }) => {
        return Array.isArray(acceptWithMimeType) && acceptWithMimeType.length
          ? acceptWithMimeType.some(
              e =>
                name.toLowerCase().endsWith(e.ext.toLowerCase()) &&
                e.type === type
            )
          : true
      })
    } else if (accept.length > 0) {
      res = Array.from(files).filter(({ name }) => {
        return Array.isArray(accept) && accept.length
          ? accept.some(ext => name.toLowerCase().endsWith(ext.toLowerCase()))
          : true
      })
    }
    return res
  }
  const handleChange = e => {
    const files = accepted(e.target.files)
    typeof onChange === 'function' && accepted.length && onChange(files)
    e.target.value = null
  }

  const handleDragEnter = e => {
    setDragging(true)

    dragEnterEl.current = e.target
  }

  const handleDragOver = e => {
    if (e.preventDefault) {
      e.preventDefault()
    }

    if (disabled) {
      e.dataTransfer.dropEffect = 'none'
    }

    return false
  }

  const handleDragLeave = e => {
    if (
      dragEnterEl.current === dropZoneEl.current &&
      e.target === dropZoneEl.current
    ) {
      setDragging(false)
    }
  }

  const handleDrop = e => {
    e.stopPropagation()
    e.preventDefault()

    setDragging(false)

    const files = accepted(e.dataTransfer.files)
    typeof onChange === 'function' && accepted.length && onChange(files)
  }

  const hancleInputClick = e => {
    if (disabled) {
      e.stopPropagation()
      e.preventDefault()
    }

    return false
  }

  const handleDragEnd = e => {
    e.stopPropagation()
    e.preventDefault()

    setDragging(false)
  }

  const handleMouseEnter = e => {
    if (dragging && !e.dataTransfer) {
      //  cleanup
      setDragging(false)
    }
  }

  return (
    <div
      className={classnames('e-uploader', className, {
        'e-uploader--danger': variant === UPLOADER_VARIANT_DANGER,
        'e-uploader--uploading': variant === UPLOADER_VARIANT_UPLOADING,
        'e-uploader--uploaded': variant === UPLOADER_VARIANT_UPLOADED,
        'e-uploader--dragging': dragging && !disabled,
        'e-uploader--disabled': disabled
      })}
      ref={dropZoneEl}
      onDragEnterCapture={handleDragEnter}
      onDragOverCapture={handleDragOver}
      onDragLeaveCapture={handleDragLeave}
      onDropCapture={handleDrop}
      onDragEndCapture={handleDragEnd}
      onMouseEnter={handleMouseEnter}
      data-mu-test={classnames('uploader', dataAttributeTest)}
    >
      <div className='e-uploader__inner'>{value || children}</div>

      <div className='e-uploader__hint'>{hint}</div>

      <input
        type='file'
        id={inputId}
        multiple={multiple}
        onChange={handleChange}
        onClick={hancleInputClick}
        accept={accept.join(',')}
        disabled={disabled}
      />
    </div>
  )
}

Uploader.defaultProps = {
  variant: UPLOADER_VARIANT_DEFAULT,
  inputId: 'file-uploader',
  hint: undefined,
  hintDragging: undefined,
  accept: [],
  acceptWithMimeType: [],
  multiple: true,
  disabled: false
}

Uploader.propTypes = {
  className: PropTypes.string,
  onChange: PropTypes.func,
  variant: PropTypes.oneOf([
    UPLOADER_VARIANT_DEFAULT,
    UPLOADER_VARIANT_DANGER,
    UPLOADER_VARIANT_UPLOADING,
    UPLOADER_VARIANT_UPLOADED
  ]),
  inputId: PropTypes.string,
  hint: PropTypes.node,
  accept: PropTypes.arrayOf(PropTypes.string),
  acceptWithMimeType: PropTypes.arrayOf(PropTypes.object),
  children: PropTypes.node,
  value: PropTypes.node,

  multiple: PropTypes.bool,
  disabled: PropTypes.bool,
  'data-mu-test': PropTypes.string
}
